import React from 'react';
import { ScrollText } from 'lucide-react';
import { useAiActivity } from './AiActivityProvider';

export function AiActivityTrigger() {
  const { isOpen, toggle } = useAiActivity();

  return (
    <button
      type="button"
      onClick={toggle}
      className={`flex items-center justify-center rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-action-blue focus:ring-offset-2 ${
        isOpen
          ? 'bg-action-blue/10 text-action-blue'
          : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700'
      }`}
      aria-label={isOpen ? 'Close AI activity panel' : 'Open AI activity panel'}
      aria-pressed={isOpen}
    >
      <ScrollText className="h-5 w-5" />
    </button>
  );
}
